import { setResponseHeader } from "h3";
import { useCDNHeaders, useRouteCache } from "#nuxt-multi-cache/composables";
import {
  BROWSER_MAX_AGE,
  CDN_EDGE_CACHE_TTL,
  CDN_STALE_WHILE_REVALIDATE,
  ROUTE_CACHE_MAX_AGE_SECONDS
} from "~/utils/routeCache";

export const useResearchTopicRouteCache = () => {
  useRouteCache((helper) => {
    helper.setMaxAge(ROUTE_CACHE_MAX_AGE_SECONDS).setCacheable();
  });

  const cdnCacheEnabled = useEnvBoolean(
    useRuntimeConfig().public.cdnCacheEnabled
  );

  if (cdnCacheEnabled) {
    useCDNHeaders((cdn) => {
      cdn.public();
      cdn.setNumeric("sharedMaxAge", CDN_EDGE_CACHE_TTL);
      cdn.setNumeric("staleWhileRevalidate", CDN_STALE_WHILE_REVALIDATE);
      cdn.setNumeric("maxAge", BROWSER_MAX_AGE);
    });
    return;
  }

  if (import.meta.server) {
    const event = useRequestEvent();
    if (event) {
      setResponseHeader(
        event,
        "cache-control",
        `max-age=${BROWSER_MAX_AGE}, must-revalidate`
      );
    }
  }
};
